import adminApi, { setAdminToken } from '@/apis/admin'

// Hydrate from sessionStorage at module load so a page refresh on
// /admin/scenarios doesn't redirect to /admin/login despite a valid
// tab-scoped token (SDD §6.8 token-hydration note).
const STORAGE_KEY = 'admin_token'
// Safari ITP throws SecurityError on sessionStorage in a cross-site iframe,
// so storage access is guarded — otherwise the Vuex store fails to construct
// when the public demo is embedded on voicesbot.com and the app blanks out.
const safeGet = () => {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) || null
  } catch (_e) {
    return null
  }
}
const safeSet = (value) => {
  try {
    if (value) window.sessionStorage.setItem(STORAGE_KEY, value)
    else window.sessionStorage.removeItem(STORAGE_KEY)
  } catch (_e) {
    // ignore
  }
}
const initialToken = safeGet()
if (initialToken) setAdminToken(initialToken)

export default {
  state: {
    token: initialToken,
    current_user: null,
    auth_pending: false
  },
  mutations: {
    SET_ADMIN_TOKEN(state, token) {
      state.token = token || null
      setAdminToken(state.token)
      safeSet(state.token)
    },
    SET_ADMIN_CURRENT_USER(state, user) {
      state.current_user = user || null
    },
    SET_ADMIN_AUTH_PENDING(state, pending) {
      state.auth_pending = !!pending
    }
  },
  actions: {
    async adminLogin({ commit }, { username, password }) {
      commit('SET_ADMIN_AUTH_PENDING', true)
      try {
        const resp = await adminApi.login({ username, password })
        const body = resp.data || {}
        if (!body.success) throw new Error(body.message || 'Login failed.')
        commit('SET_ADMIN_TOKEN', body.data.token)
        commit('SET_ADMIN_CURRENT_USER', body.data.user)
        return body
      } finally {
        commit('SET_ADMIN_AUTH_PENDING', false)
      }
    },
    async adminLogout({ commit, state }) {
      try {
        if (state.token) await adminApi.logout()
      } catch (_e) {
        // server-side logout is best-effort; client-side drop is the source of truth
      }
      commit('SET_ADMIN_TOKEN', null)
      commit('SET_ADMIN_CURRENT_USER', null)
    },
    async hydrateAdminUser({ commit, state }) {
      if (!state.token) return
      try {
        const resp = await adminApi.me()
        const body = resp.data || {}
        if (body.success) commit('SET_ADMIN_CURRENT_USER', body.data)
        else commit('SET_ADMIN_TOKEN', null) // stale token → drop
      } catch (_e) {
        commit('SET_ADMIN_TOKEN', null)
      }
    }
  }
}
